<div class="loading-screen-wrapper" *ngIf="loading">
  <div class="loading-screen-icon">    
    <div class="d-flex justify-content-center">
      <div class="spinner-border spinner-border-sm text-info" style="width: 6rem; height: 6rem;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</div>